import React from "react";
import ReactApexChart from "react-apexcharts";

const BusinessChartComponent = ({ businessTypes }) => {

  const categories = businessTypes?.map((item) => item.name + ` (${item.businesses_count})`);
  const data = businessTypes?.map((item) => item.businesses_count);
  const chartData = {
    series: [
      {
        name: "",
        data,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false, // Disable the hamburger menu
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: "80%",
          isFunnel: true,
        },
      },
      colors: [
        "#F44F5E",
        "#E55A89",
        "#D863B1",
        "#CA6CD8",
        "#B57BED",
        "#8D95EB",
        "#62ACEA",
        "#4BC3E6",
      ],
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex];
        },
        dropShadow: {
          enabled: true,
        },
      },
      title: {
        text: "Business Startups",
        align: "middle",
      },
      xaxis: {
        categories
      },
      legend: {
        show: false,
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default BusinessChartComponent;
